module.exports = "/assets/review-girl.png?wjG9eeJ";